
import { defineComponent, PropType, ref, toRef, watch } from "vue";
import { TranslationService } from "@/core/services/TranslationService";
import VZModal from "@/components/content/VZModal.vue";
import { ISite } from "@/interfaces/iSite";
import DeviceDetail from "@/views/site/views/DeviceDetail.vue";

export default defineComponent({
  emit: ["close-detail"],
  name: "device-detail-modal",
  components: { VZModal, DeviceDetail },
  props: {
    value: { type: Boolean, default: false },
    viewName: { type: String, default: "" },
    data: { type: Object as PropType<ISite>, required: true },
    loading: { type: Boolean, default: false },
    showDialog: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const close = () => {
      emit("close-detail");
    };

    return {
      close,
      t,
    };
  },
});
